import React from 'react';
import {useDispatch} from "react-redux";
import IntlMessage from "../../../../components/IntlMessage/IntlMessage";
import {Flex, Tabs} from "antd";
import MyText from "../../../../components/UI/Text/MyText";
import MicroQualificationList from "./MicroQualificationList/MicroQualificationList";
import EducationFieldPage from "./MicroQualificationList/EducationFieldPage";
import TrainingDirectionPage from "./MicroQualificationList/TrainingDirectionPage";
import GroupEpPage from "./MicroQualificationList/GroupEpPage";
import PartnerOrganizationPage from "./MicroQualificationList/PartnerOrganizationPage";
import ProfessionalStandardsPage from "./MicroQualificationList/ProfessionalStandardsPage";

const MicroQualificationPage = () => {
    const dispatch = useDispatch();

    const onChangeTabs = async (key) => {
        // if (key === '1') {
        //     await dispatch(getAllGlobalValues());
        // }
    };

    const tabItems = [
        {
            key: '1',
            label: <IntlMessage id={'list'}/>,
            children: <MicroQualificationList/>,
        },
        {
            key: '2',
            label: <IntlMessage id={'educationField'}/>,
            children: <EducationFieldPage/>,
        },
        {
            key: '3',
            label: <IntlMessage id={'trainingDirection'}/>,
            children: <TrainingDirectionPage/>,
        },
        {
            key: '4',
            label: <IntlMessage id={'groupEP'}/>,
            children: <GroupEpPage/>,
        },
        {
            key: '5',
            label: <IntlMessage id={'partnerOrg'}/>,
            children: <PartnerOrganizationPage/>,
        },
        {
            key: '6',
            label: <IntlMessage id={'profStandards'}/>,
            children: <ProfessionalStandardsPage/>,
        }

    ]

    return (
        <Flex style={{width: "100%"}} align={"flex-start"} justify={"flex-start"} vertical gap={20}>
            <MyText uppercase strong size={"large"}><IntlMessage id={'microQEP'}/></MyText>
            <Tabs style={{width: "100%"}} defaultActiveKey={"1"} type="card" items={tabItems} onChange={onChangeTabs}/>
        </Flex>
    );
};

export default MicroQualificationPage;